"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaultClient = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const covered_call_vault_json_1 = __importDefault(require("../idl/covered_call_vault.json"));
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const utils = __importStar(require("../common/utils"));
const instructions = __importStar(require("./instructions"));
const vault_1 = require("./vault");
const program_1 = require("../common/program");
const constants_1 = require("../common/constants");
class VaultClient {
    constructor(connection, wallet, opts = utils.defaultCommitment()) {
        this._vaultTokens = [];
        this._queuedDeposits = [];
        this._queuedWithdrawals = [];
        this._provider = new anchor.AnchorProvider(connection, wallet, opts);
        this._program = new anchor.Program(covered_call_vault_json_1.default, vault_1.vault.programId, this._provider);
    }
    /**
     * Anchor program instance.
     */
    get program() {
        return this._program;
    }
    get programId() {
        return this._program.programId;
    }
    /**
     * Anchor provider instance.
     */
    get provider() {
        return this._provider;
    }
    get publicKey() {
        return this._provider.wallet.publicKey;
    }
    get vaultTokens() {
        return this._vaultTokens;
    }
    get queuedDeposits() {
        return this._queuedDeposits;
    }
    get queuedWithdrawals() {
        return this._queuedWithdrawals;
    }
    static async load(connection, wallet, opts = utils.defaultCommitment()) {
        if (!vault_1.vault.isInitialized) {
            throw Error("Vault isn't loaded yet");
        }
        let client = new VaultClient(connection, wallet, opts);
        await client.updateState();
        return client;
    }
    async depositVault(vault, amount) {
        let vaultInfo = vault_1.vault.getVault(vault);
        let underlyingTokenAccountAddress;
        let tx = new web3_js_1.Transaction();
        let keypair;
        if (vaultInfo.underlyingMint.equals(constants_1.SOL_PUBKEY)) {
            [tx, keypair] = await utils.createWrappedNativeAccount(this._provider.connection, this.publicKey, this.publicKey, amount.toNumber());
            underlyingTokenAccountAddress = keypair.publicKey;
        }
        else {
            try {
                underlyingTokenAccountAddress = await (0, spl_token_1.getAssociatedTokenAddress)(vaultInfo.underlyingMint, this.publicKey);
                await (0, spl_token_1.getAccount)(this._provider.connection, underlyingTokenAccountAddress);
            }
            catch (e) {
                throw Error(`User does not have associated token account for ${vaultInfo.underlyingMint.toString}. Deposit failed.`);
            }
        }
        let redeemableTokenAccountAddress = await (0, spl_token_1.getAssociatedTokenAddress)(vaultInfo.redeemableMint, this.publicKey);
        try {
            await (0, spl_token_1.getAccount)(this._provider.connection, redeemableTokenAccountAddress);
        }
        catch (e) {
            `User does not have associated token account for redeemable mint. Creating account.`;
            tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(this.publicKey, redeemableTokenAccountAddress, this.publicKey, vaultInfo.redeemableMint));
        }
        tx.add(await instructions.depositVaultIx(amount, vaultInfo.address, this.publicKey, underlyingTokenAccountAddress, redeemableTokenAccountAddress, vaultInfo.underlyingMint, vaultInfo.redeemableMint));
        let txSig = await utils.processTransaction(program_1.Program.VAULT, this._provider, tx, [keypair]);
        await this.updateTokenState();
        return txSig;
    }
    async removeQueuedDeposit(vault, queueNodeToRemove) {
        let vaultInfo = vault_1.vault.getVault(vault);
        let depositQueueHeaderInfo = await this._program.account.queueHeader.fetch(vaultInfo.vaultDepositQueueHeaderAddress);
        if (depositQueueHeaderInfo.count.toNumber() == 0) {
            throw Error("Cannot remove queued deposit from empty queue.");
        }
        let currNodeInfo;
        let currNodeAddress = depositQueueHeaderInfo.head;
        let prevNodeAddress = null;
        let depositQueue = vaultInfo.depositQueue;
        for (var i = 0; i < depositQueue.length; i++) {
            currNodeInfo = depositQueue[i].info;
            if (currNodeAddress.equals(queueNodeToRemove)) {
                break;
            }
            prevNodeAddress = currNodeAddress;
            currNodeAddress = currNodeInfo.nextNode;
        }
        if (currNodeAddress.equals(web3_js_1.PublicKey.default)) {
            throw Error("Queue node to remove doesn't exist.");
        }
        if (!currNodeInfo.userKey.equals(this.publicKey)) {
            throw Error("Cannot remove a queue node that you do not own.");
        }
        let underlyingTokenAccountAddress = await (0, spl_token_1.getAssociatedTokenAddress)(vaultInfo.underlyingMint, this.publicKey);
        let tx = new web3_js_1.Transaction();
        try {
            await (0, spl_token_1.getAccount)(this._provider.connection, underlyingTokenAccountAddress);
        }
        catch (e) {
            `User does not have associated token account for underlying mint. Creating account.`;
            tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(this.publicKey, underlyingTokenAccountAddress, this.publicKey, vaultInfo.underlyingMint));
        }
        let remainingAccounts = [];
        if (!queueNodeToRemove.equals(depositQueueHeaderInfo.head)) {
            remainingAccounts.push({
                pubkey: prevNodeAddress,
                isSigner: false,
                isWritable: true,
            });
        }
        tx.add(await instructions.removeQueuedDepositIx(this.publicKey, underlyingTokenAccountAddress, vaultInfo, currNodeAddress, remainingAccounts));
        return await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
    }
    async removeQueuedWithdrawal(vault, queueNodeToRemove) {
        let vaultInfo = vault_1.vault.getVault(vault);
        let withdrawQueueHeaderInfo = await this._program.account.queueHeader.fetch(vaultInfo.vaultWithdrawQueueHeaderAddress);
        if (withdrawQueueHeaderInfo.count.toNumber() == 0) {
            throw Error("Cannot remove queued withdraw from empty queue.");
        }
        let currNodeInfo;
        let currNodeAddress = withdrawQueueHeaderInfo.head;
        let prevNodeAddress;
        let withdrawalQueue = vaultInfo.withdrawalQueue;
        for (var i = 0; i < withdrawalQueue.length; i++) {
            currNodeInfo = withdrawalQueue[i].info;
            if (currNodeAddress.equals(queueNodeToRemove)) {
                break;
            }
            prevNodeAddress = currNodeAddress;
            currNodeAddress = currNodeInfo.nextNode;
        }
        if (currNodeAddress.equals(web3_js_1.PublicKey.default)) {
            throw Error("Queue node to remove doesn't exist.");
        }
        if (!currNodeInfo.userKey.equals(this.publicKey)) {
            throw Error("Cannot remove a queue node that you do not own.");
        }
        let redeemableTokenAccountAddress = await (0, spl_token_1.getAssociatedTokenAddress)(vaultInfo.redeemableMint, this.publicKey);
        let tx = new web3_js_1.Transaction();
        try {
            await (0, spl_token_1.getAccount)(this._provider.connection, redeemableTokenAccountAddress);
        }
        catch (e) {
            `User does not have associated token account for redeemable mint. Creating account.`;
            tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(this.publicKey, redeemableTokenAccountAddress, this.publicKey, vaultInfo.redeemableMint));
        }
        let remainingAccounts = [];
        if (!queueNodeToRemove.equals(withdrawQueueHeaderInfo.head)) {
            remainingAccounts.push({
                pubkey: prevNodeAddress,
                isSigner: false,
                isWritable: true,
            });
        }
        tx.add(await instructions.removeQueuedWithdrawIx(this.publicKey, redeemableTokenAccountAddress, vaultInfo, currNodeAddress, remainingAccounts));
        return await utils.processTransaction(program_1.Program.VAULT, this._provider, tx);
    }
    getQueuedDeposits(vault) {
        let vaultInfo = vault_1.vault.getVault(vault);
        let depositQueue = vaultInfo.depositQueue;
        let userQueue = [];
        for (let i = 0; i < depositQueue.length; i++) {
            if (depositQueue[i].info.userKey.equals(this.publicKey)) {
                userQueue.push(depositQueue[i]);
            }
        }
        return userQueue;
    }
    getQueuedWithdrawals(vault) {
        let vaultInfo = vault_1.vault.getVault(vault);
        let withdrawalQueue = vaultInfo.withdrawalQueue;
        let userQueue = [];
        for (let i = 0; i < withdrawalQueue.length; i++) {
            if (withdrawalQueue[i].info.userKey.equals(this.publicKey)) {
                userQueue.push(withdrawalQueue[i]);
            }
        }
        return userQueue;
    }
    async withdrawVault(vault, amount) {
        let vaultInfo = vault_1.vault.getVault(vault);
        let redeemableTokenAccountAddress = await (0, spl_token_1.getAssociatedTokenAddress)(vaultInfo.redeemableMint, this.publicKey);
        try {
            await (0, spl_token_1.getAccount)(this._provider.connection, redeemableTokenAccountAddress);
        }
        catch (e) {
            throw Error(`User does not have associated token account for redeemable mint. Withdrawal failed.`);
        }
        let tx = new web3_js_1.Transaction();
        let underlyingTokenAccountAddress = undefined;
        let keypair;
        if (vaultInfo.underlyingMint.equals(constants_1.SOL_PUBKEY)) {
            [tx, keypair] = await utils.createWrappedNativeAccount(this._provider.connection, this.publicKey, this.publicKey, 0);
            underlyingTokenAccountAddress = keypair.publicKey;
        }
        else {
            try {
                underlyingTokenAccountAddress = await (0, spl_token_1.getAssociatedTokenAddress)(vaultInfo.underlyingMint, this.publicKey);
                await (0, spl_token_1.getAccount)(this._provider.connection, underlyingTokenAccountAddress);
            }
            catch (e) {
                console.log(`User does not have associated token account for ${vaultInfo.underlyingMint.toString}. Creating now.`);
                tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(this.publicKey, underlyingTokenAccountAddress, this.publicKey, vaultInfo.underlyingMint));
            }
        }
        tx.add(await instructions.withdrawVaultIx(this.publicKey, amount, underlyingTokenAccountAddress, redeemableTokenAccountAddress, vault));
        let txSig = await utils.processTransaction(program_1.Program.VAULT, this._provider, tx, [keypair]);
        await this.updateTokenState();
        return txSig;
    }
    async updateTokenState() {
        let vaultTokens = [];
        await Promise.all(vault_1.vault.vaults.map(async (vault) => {
            let redeemableTokenAccountAddress = await (0, spl_token_1.getAssociatedTokenAddress)(vault.redeemableMint, this.publicKey);
            let tokens = 0;
            try {
                let tokenAccount = await (0, spl_token_1.getAccount)(this._provider.connection, redeemableTokenAccountAddress);
                tokens = Number(tokenAccount.amount);
            }
            catch (e) { }
            vaultTokens.push({
                vault: vault.address,
                tokenAccount: redeemableTokenAccountAddress,
                amount: tokens,
            });
        }));
        this._vaultTokens = vaultTokens;
    }
    async updateState() {
        await vault_1.vault.updateState();
        await this.updateTokenState();
        this._queuedDeposits = [];
        this._queuedWithdrawals = [];
        await Promise.all(vault_1.vault.vaults.map(async (vault) => {
            this._queuedDeposits.push({
                vault: vault.address,
                nodes: this.getQueuedDeposits(vault.address),
            });
            this._queuedWithdrawals.push({
                vault: vault.address,
                nodes: this.getQueuedWithdrawals(vault.address),
            });
        }));
    }
    getRedeemableTokenAmount(vault) {
        for (var i = 0; i < this._vaultTokens.length; i++) {
            if (this._vaultTokens[i].vault.equals(vault)) {
                return this._vaultTokens[i].amount;
            }
        }
        throw Error("Vault does not exist!");
    }
}
exports.VaultClient = VaultClient;
